import { PosIconProps, SvgWrapper } from './SvgWrapper';

export function PlusTicketIcon(props: Omit<PosIconProps, 'viewBox'>) {
  return (
    <SvgWrapper {...props} viewBox="0 0 12 12">
      <path
        d="M6.56244 4.3125C6.56244 4.00184 6.3106 3.75 5.99994 3.75C5.68928 3.75 5.43744 4.00184 5.43744 4.3125V5.4375H4.3125C4.00184 5.4375 3.75 5.68934 3.75 6C3.75 6.31066 4.00184 6.5625 4.3125 6.5625H5.43744V7.6875C5.43744 7.99816 5.68928 8.25 5.99994 8.25C6.3106 8.25 6.56244 7.99816 6.56244 7.6875V6.5625H7.6875C7.99816 6.5625 8.25 6.31066 8.25 6C8.25 5.68934 7.99816 5.4375 7.6875 5.4375H6.56244V4.3125Z"
        fill="inherit"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.2009 11.25C2.46863 11.25 1.87501 10.6624 1.87501 9.9375L1.875 2.0625C1.875 1.33763 2.46862 0.75 3.20089 0.75H4.82143C4.82143 1.39433 5.34909 1.91667 6 1.91667C6.6509 1.91667 7.17857 1.39433 7.17857 0.75H8.7991C9.53137 0.75 10.125 1.33763 10.125 2.0625L10.125 9.9375C10.125 10.6624 9.53138 11.25 8.79911 11.25H7.17857C7.17857 10.6057 6.65091 10.0833 6 10.0833C5.3491 10.0833 4.82143 10.6057 4.82143 11.25H3.2009ZM3.2009 10.125C3.07916 10.125 3.00001 10.0303 3.00001 9.9375L3 2.0625C3 1.96969 3.07915 1.875 3.20089 1.875H3.99221C4.38915 2.57425 5.14409 3.04167 6 3.04167C6.8559 3.04167 7.61084 2.57425 8.00778 1.875H8.7991C8.92084 1.875 8.99999 1.96969 8.99999 2.0625L9 9.9375C9 10.0303 8.92085 10.125 8.79911 10.125H8.00779C7.61085 9.42575 6.85591 8.95833 6 8.95833C5.1441 8.95833 4.38916 9.42575 3.99222 10.125H3.2009Z"
        fill="inherit"
      />
    </SvgWrapper>
  );
}
